<template>
  <div>
    <div class="color_grey_dark text-uppercase font-weight-bold">
      Catchup! Reminder
    </div>

    <div class="reminders-container">
      <div class="reminder-card mr-3 rounded text-center">
        <div class="font-14 font-weight-600 brand_navy">Mon</div>
        <div class="font-11 color_ash mt-1">5:00pm</div>
      </div>

      <div class="reminder-card  mr-3 rounded text-center">
        <div class="font-14 font-weight-600 brand_navy">Tues</div>
        <div class="font-11 color_ash mt-1">6:00am</div>
      </div>

      <div class="reminder-card  mr-3 rounded text-center">
        <div class="font-14 font-weight-600 brand_navy">Wed</div>
        <div class="font-11 color_ash mt-1">10:00pm</div>
      </div>
    </div>

    <div
      class="container-option mt-3 d-flex justify-content-start align-items-center nowrap"
      @click="reminder_modal = true"
    >
      <div class="avatar pointer border mr-2">
        <span class="flex-center icon-swap brand_accent font-17"></span>
      </div>

      <div
        class="label-text font-weight-bold brand_accent font-13-5 pointer btn-link"
      >
        Update Catchup
      </div>
    </div>

    <update-catchup-reminder-modal
      v-if="reminder_modal"
      @closeTriggered="reminder_modal = false"
    />
  </div>
</template>

<script>
import UpdateCatchupReminderModal from "@/components/modalComps/settingsModals/UpdateCatchupReminderModal";

export default {
  name: "StudentCatchupReminderContainer",

  components: {
    UpdateCatchupReminderModal,
  },

  data() {
    return {
      reminder_modal: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.reminders-container {
  @include flex_row_start_wrap;
  margin-top: 15px;

  .reminder-card {
    border: 1.5px solid $brand_inverse_light;
    padding: 5px 10px;

    transition: transform ease-in-out 0.4s;
    &:hover {
      transform: scale(0.92);
    }
  }
}
</style>
